import React from 'react';

import './SideNavHeader.scss';

type SiteNavHeaderProps = {
    children: React.ReactNode;
};

export default class SideNavHeader extends React.Component<SiteNavHeaderProps> {
    render() {
        return <div className="sideNavHeader">{this.props.children}</div>;
    }
}
